function UserService($q, AppSettings, AuthService, CommonService) {
  'ngInject';

  const service = {};

  // 국가 목록
  service.getCountries = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'user/countries';

    return CommonService.post(url, params);
  };

  // 종목 목록
  service.getSports = function () {
    const url = AppSettings.apiUrl.restRoot + 'user/sports';

    return CommonService.post(url);
  };

  // 신분 목록
  service.getUserTypes = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'user/user_types';

    return CommonService.post(url, params);
  };

  // 포지션 목록
  service.getPositions = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'user/positions';

    return CommonService.post(url, params);
  };

  // 자격 목록
  service.getLicenses = function () {
    const url = AppSettings.apiUrl.restRoot + 'user/licenses';

    return CommonService.post(url);
  };

  // 팀 목록
  service.getTeams = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'user/teams';

    return CommonService.post(url, params);
  };

  // 동작 목록
  service.getMovements = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'user/movements';

    return CommonService.post(url, params);
  };

  // 아이디 중복확인
  service.isDuplicate = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'user/is_duplicate';

    return CommonService.post(url, params);
  };

  // 인증번호 전송
  service.sendCode = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'user/send_code';

    return CommonService.post(url, params);
  };

  // 인증번호 일치 여부
  service.verifyCode = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'user/verify_code';

    return CommonService.post(url, params);
  };


  // upload Image
  service.uploadImage = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'user/upload_image';
    return CommonService.post(url, params);
  };


  // upload File
  service.uploadFile = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'user/upload_file';
    return CommonService.post(url, params);
  };





  // 회원가입
  service.join = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'user/join';

    return CommonService.post(url, params);
  };

  // 회원수정
  service.modify = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'user/modify';

    return CommonService.post(url, params);
  };

  // 로그인
  service.login = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'user/login';

    return CommonService.post(url, params);
  };

  // 아이디 찾기
  service.findId = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'user/find_id';

    return CommonService.post(url, params);
  };

  // 비밀번호 초기화
  service.resetPass = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'user/reset_pass';

    return CommonService.post(url, params);
  };

  // 초기화된 비밀번호 전송
  service.sendPass = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'user/send_pass';

    return CommonService.post(url, params);
  };

  // 로그아웃
  service.logout = function () {
    const d = $q.defer();
    AuthService.removeCurrentUser();
    d.resolve();
    return d.promise;
  };


  // 회원정보 조회
  service.info = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'user/info';

    return CommonService.post(url, params);
  };

  //회원 승인
  service.approve = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'user/approve';

    return CommonService.post(url, params);
  }

  //회원목록
  service.getUserList = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'user/list';
    return CommonService.post(url, params);
  }

  //선수 방출
  service.release = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'user/release';
    return CommonService.post(url, params);
  }

  //개인 일정 메일 전송
  service.sendPlayerSchedule = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'user/send_schedule';

    return CommonService.post(url, params);
  };

  // 인증번호 생성
  service.generateCode = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'user/generate_code';

    return CommonService.post(url, params);
  };

  // 인증번호 전송
  service.sendCodeMail = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'user/send_code_mail';

    return CommonService.post(url, params);
  }

  // 팀 조회
  service.teamInfo = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'user/team_info';

    return CommonService.post(url, params);
  };

  // 운동장 생성
  service.addStadium = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'user/add_stadium';

    return CommonService.post(url, params);
  };

  // 운동장 삭제
  service.removeStadium = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'user/remove_stadium';

    return CommonService.post(url, params);
  };

  // 결제
  service.pay = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'user/pay';

    return CommonService.post(url, params);
  };

  // 결제 이력
  service.paymentHistory = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'user/payment_history';

    return CommonService.post(url, params);
  };

  // 1경기 사용
  service.consume = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'user/consume';

    return CommonService.post(url, params);
  };

  // 이적, 발탁 요청 이력
  service.reqList = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'user/req_list';

    return CommonService.post(url, params);
  };

  // 이적, 발탁 요청
  service.require = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'user/req';

    return CommonService.post(url, params);
  };

  // 요청 취소
  service.cancelReq = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'user/cancel_req';

    return CommonService.post(url, params);
  };

  // 동의
  service.agreeReq = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'user/agree_req';

    return CommonService.post(url, params);
  };

  // 거절
  service.rejectReq = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'user/reject_req';

    return CommonService.post(url, params);
  };

  // 소유 팀 조회 (구단주나 단장만 사용)
  service.myTeams = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'user/my_teams';

    return CommonService.post(url, params);
  };

  return service;

}

export default {
  name: 'UserService',
  fn: UserService
};
